import {
  FETCH_LOCATIONS_SUCCESS,
  FETCH_ORGANIZATIONS,
  FETCH_ORGANIZATIONS_ERROR,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_PAYMENT_TYPES,
  FETCH_PAYMENT_TYPES_SUCCESS,
  SEND_IIKO_ORGANIZATIONS_SUCCESS,
  FETCH_PAYMENT_TYPES_ERROR,
  GET_LOCATION_BY_ID_SUCCESS,
  CLEAN_LOCATION_FORM,
  FETCH_ALL_LOCATIONS,
  SET_NEXT_IN_PROGRESS_LOADER,
  CREATE_GLOVO_INTEGRATION_SUCCESS,
  FETCH_CASH_SYSTEM_SUCCESS,
  SET_LOCATION_DRAWER_LOADING,
  GET_AGGREGATOR_DATA_SUCCESS,
  CLEAR_AGGREGATOR_DATA,
  GET_AGGREGATOR_DATA_SAGA,
  FETCH_ORDER_TYPES_SUCCESS,
  GET_POS_IDS_SUCCESS,
  GET_YANDEX_CREDENTIALS_SUCCESS,
} from "./types/actionTypes";

const initialState = {
  locations: [],

  organizations: [],
  payment_types: [],
  order_types: [],

  point_ids: [],

  yandex_credentials: {},

  fetchLocation: true,
  loading: false,
  nextInProgress: false,
  drawerLoader: false,

  agregatorsForms: {},
  cashSystemForms: {},

  page: 1,
  page_count: 0,
  total_count: 0,

  field: null,
  direction: null,
};

const locationsReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.payload.data,
        page: action.payload.metadata.page,
        page_count: action.payload.metadata.page_count,
        total_count: action.payload.metadata.total_count,
        field: action.payload.metadata.field,
        direction: action.payload.metadata.direction,
      };

    case GET_POS_IDS_SUCCESS:
      return {
        ...state,
        point_ids: action.payload,
      };

    case FETCH_ORGANIZATIONS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.payload,
        loading: false,
      };
    case FETCH_ORGANIZATIONS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case FETCH_PAYMENT_TYPES:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PAYMENT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        payment_types: action.payload,
      };
    case FETCH_PAYMENT_TYPES_ERROR:
      return {
        ...state,
        loading: false,
        drawerLoader: false,
      };

    case SEND_IIKO_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        nextInProgress: false,
        cashSystemForms: {},
      };
    case CREATE_GLOVO_INTEGRATION_SUCCESS: {
      return {
        ...state,
        cashSystemForms: action.payload,
        nextInProgress: false,
      };
    }
    case GET_LOCATION_BY_ID_SUCCESS:
      return {
        ...state,
        locationForms: action.payload,
      };
    case CLEAN_LOCATION_FORM:
      return {
        ...state,
        locationForms: {},
      };
    case FETCH_ALL_LOCATIONS:
      return {
        ...state,
        fetchLocation: true,
      };

    case SET_NEXT_IN_PROGRESS_LOADER:
      return {
        ...state,
        nextInProgress: action.payload,
      };
    case FETCH_CASH_SYSTEM_SUCCESS:
      return {
        ...state,
        cashSystemForms: action.payload,
      };
    case SET_LOCATION_DRAWER_LOADING:
      return {
        ...state,
        drawerLoader: action.payload,
      };

    case GET_AGGREGATOR_DATA_SAGA:
      return {
        ...state,
        drawerLoader: true,
      };
    case GET_AGGREGATOR_DATA_SUCCESS:
      return {
        ...state,
        agregatorsForms: action.payload,
        drawerLoader: false,
      };
    case FETCH_ORDER_TYPES_SUCCESS:
      return {
        ...state,
        order_types: action.payload,
      };
    case CLEAR_AGGREGATOR_DATA:
      return { ...state, agregatorsForms: {}, drawerLoader: false };

    case GET_YANDEX_CREDENTIALS_SUCCESS:
      return {
        ...state,
        yandex_credentials: action.payload,
      };

    default:
      return state;
  }
};

export default locationsReducer;
